import { FC } from 'react';
import { HomeFilled } from '@ant-design/icons';
import { Avatar, Typography } from 'antd';

import {
	ApplicationReviewStyled,
	ReviewContentStyled,
	ReviewHeaderStyled,
	ReviewHeaderTextContainerStyled,
} from './ApplicationReview.styles';

interface Props {
	title: string;
	content: string;
	author: string;
	date: string;
	currIndex: number;
	avatarUrl?: string;
}

const { Text, Title } = Typography;

export const ApplicationReview: FC<Props> = ({ title, content, author, date, currIndex, avatarUrl }) => (
	<ApplicationReviewStyled $currIndex={currIndex}>
		<ReviewHeaderStyled>
			<Avatar src={avatarUrl} icon={<HomeFilled style={{ fontSize: `18px` }} />} size={40} shape='circle' />
			<ReviewHeaderTextContainerStyled>
				<Text>{author}</Text>
				<Text type='secondary' style={{ fontSize: `12px` }}>
					{date}
				</Text>
			</ReviewHeaderTextContainerStyled>
		</ReviewHeaderStyled>
		<ReviewContentStyled>
			<Title level={4} style={{ marginBottom: `0` }}>
				{title}
			</Title>
			<Text>{content}</Text>
		</ReviewContentStyled>
	</ApplicationReviewStyled>
);
